import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Errors extends Component {

  render() {
    return (
      <ul className="errors-container">
        {this.props.errorsMsgs.map((item, index) => (
          <li className='error' key={index}>{item}</li>
        ))}
      </ul>
    )
  }
}

Errors.propTypes = {
  errorsMsgs: PropTypes.array
};

export default Errors;


// WEBPACK FOOTER //
// ./src/components/errors.js